import axiosIns from '@axios'

/**
 * FILE-516: файлы, прикреплённые к заданию агенту (ТЗ «Файлы в Вики Кубус» §2, §9.2, §14.1).
 *
 * КОГДА КНОПКА ЕСТЬ. Только если `/api/whoami` принёс поле `agentattachments`. Его нет, если
 * прикрепление выключено на сервере, в домене не раскатана процедура следа памяти или у человека
 * нет роли памяти. Кнопка, которая «есть, но не работает», хуже её отсутствия — поэтому признак
 * решает сервер, а не догадка клиента.
 *
 * ПОЧЕМУ ЗАГРУЗКА СРАЗУ ПРИ ВЫБОРЕ, А НЕ С ОТПРАВКОЙ. Отказ по размеру, числу и формату должен
 * прийти ДО отправки задания (§9.2): человек видит его у файла и не ждёт минуту ответа агента,
 * чтобы узнать, что файл не подошёл. Сервер проверяет пределы при загрузке — клиент их не
 * повторяет, чтобы не завести второй, расходящийся с сервером список правил.
 */

/** Пределы и признак из ответа `whoami`. `null` — прикрепление здесь недоступно. */
export function attachmentsFromWhoami(data) {
  const a = data && typeof data === 'object' ? data.agentattachments : null
  if (!a || typeof a !== 'object') return null
  return {
    maxsize: Number(a.maxsize) || 0,
    maxcount: Number(a.maxcount) || 0,
    maxtotal: Number(a.maxtotal) || 0,
    formats: Array.isArray(a.formats) ? a.formats : [],
  }
}

/**
 * BFILE-558 (ТЗ моста §2 п. 1, §13 п. 2): у ЛОКАЛЬНОГО Клода признак СВОЙ — `agentlocalattachments`.
 *
 * Признак раннера сюда не годится: он выдаётся по выключателю раннера, и скрепка в локальной
 * панели появлялась бы (или не появлялась) по чужому решению. Пределы у моста тоже свои.
 */
export function localAttachmentsFromWhoami(data) {
  const a = data && typeof data === 'object' ? data.agentlocalattachments : null
  if (!a || typeof a !== 'object') return null
  return {
    maxsize: Number(a.maxsize) || 0,
    maxcount: Number(a.maxcount) || 0,
    maxtotal: Number(a.maxtotal) || 0,
    formats: Array.isArray(a.formats) ? a.formats : [],
  }
}

/** Оба признака одним запросом: панель показывает то один агент, то другой. */
export async function loadAttachmentsConfig() {
  const res = await axiosIns.post('/api/whoami', {})
  const data = res && res.data
  // PROP-813: организация выключила свой ИИ — «Локальный Клод» не предлагается (нет поля — включён)
  return { runner: attachmentsFromWhoami(data), local: localAttachmentsFromWhoami(data), ownAi: !(data && data.ownai === false) }
}

/** Атрибут `accept` для выбора файла: подсказка диалогу, а не проверка. */
export function acceptOf(cfg) {
  return cfg && cfg.formats.length ? cfg.formats.map(f => `.${f}`).join(',') : ''
}

export function humanSize(bytes) {
  const b = Number(bytes) || 0
  if (b < 1024) return `${b} байт`
  if (b < 1024 * 1024) return `${(b / 1024).toFixed(b % 1024 ? 1 : 0)} КБ`
  return `${(b / (1024 * 1024)).toFixed(b % (1024 * 1024) ? 1 : 0)} МБ`
}

/**
 * Загрузить выбранные файлы. Возвращает `[{id, name, size, sha256}]` или бросает `Error` с текстом
 * сервера: отказ по пределам, по роли, скан — человек читает его как есть.
 */
export async function uploadAttachments(fileList) {
  const form = new FormData()
  Array.from(fileList || []).forEach((f, i) => form.append(`file${i}`, f, f.name))
  try {
    const res = await axiosIns.post('/api/agent/attach', form, { headers: { 'Content-Type': 'multipart/form-data' } })
    const data = (res && res.data) || {}
    if (data.error) throw new Error(data.error)
    return Array.isArray(data.files) ? data.files : []
  } catch (e) {
    const msg = e && e.response && e.response.data && e.response.data.error
    throw new Error(msg || (e && e.message) || 'Файл не загружен')
  }
}
